export class TransformationRuleDefinitionDTO{
    public id!: number;
    public name!: string;
    public description!: string;
    public ruleType!: string;
    public outputFileType!: string;
    public inputDataType!: string;
    public outputDataType!: string;
    public inputDataCount!: number;
    public parameterCount!: number;
    public parameterLabels!: string;
}